import type { EnvironmentId } from "@afar-research/contracts";
import type { HostEnvironmentRequestError } from "../rpc/http.ts";
import {
  ConnectionBlockedError,
  type ConnectionAttemptError,
  ConnectionTransientError,
} from "./model.ts";

export function profileMissingError(connectionId: string): ConnectionBlockedError {
  return new ConnectionBlockedError({
    reason: "configuration",
    detail: `Connection profile ${connectionId} is unavailable.`,
  });
}

export function environmentMismatchError(input: {
  readonly expected: EnvironmentId;
  readonly actual: EnvironmentId;
}): ConnectionBlockedError {
  return new ConnectionBlockedError({
    reason: "configuration",
    detail: `Connected environment ${input.actual} does not match ${input.expected}.`,
  });
}

export function mapHostEnvironmentError(
  error: HostEnvironmentRequestError,
): ConnectionAttemptError {
  switch (error._tag) {
    case "EnvironmentUnauthorizedError":
      return new ConnectionBlockedError({
        reason: "configuration",
        detail: "The Environment Access session is unavailable or expired.",
        traceId: error.traceId,
      });
    case "EnvironmentRequestInvalidError":
      return new ConnectionBlockedError({
        reason: "configuration",
        detail: "The environment rejected the request.",
        traceId: error.traceId,
      });
    case "HostEnvironmentTimeoutError":
      return new ConnectionTransientError({
        reason: "timeout",
        detail: error.message,
      });
    case "HostEnvironmentFetchError":
      return new ConnectionTransientError({
        reason: "network",
        detail: error.message,
      });
    case "EnvironmentInternalError":
      return new ConnectionTransientError({
        reason: "host-unavailable",
        detail: "The environment could not complete the request.",
        traceId: error.traceId,
      });
    case "HostEnvironmentInvalidJsonError":
    case "HostEnvironmentUndeclaredStatusError":
      return new ConnectionTransientError({
        reason: "host-unavailable",
        detail: error.message,
      });
  }
}
